import { defineComponent as S, ref as h, useAttrs as y, computed as T, watch as b, onMounted as E, unref as t, openBlock as o, createElementBlock as u, mergeProps as k, createElementVNode as N, createVNode as A, createCommentVNode as i, renderSlot as v, createBlock as s, normalizeClass as w, normalizeStyle as B } from "vue";
import C from "../sequiter-image/sequiter-image.vue.js";
import L from "../shimmer/shimmer.vue.js";
import { BUTTON_VARIANTS as O } from "./button-variants.js";
import { BUTTON_TYPE as U } from "./button-type.js";
import { BUTTON_STATE as r } from "./button-state.js";
import { LoadingStateManager as z } from "../../loading-state/loading-state-manager.js";
import { LoadingStateInjectionFacade as I } from "../../injection/loading-state-injection-facade.js";
import j from "../processing-animation/processing-animation.vue.js";
import q from "../check-mark/check-mark.vue.js";
const M = ["type", "disabled"], P = { class: "button-content" }, V = {
  key: 0,
  class: "image-wrapper"
}, W = /* @__PURE__ */ S({
  name: "sequiter-button",
  inheritAttrs: !1,
  __name: "sequiter-button",
  props: {
    variant: { default: O.SECONDARY },
    larger: { type: Boolean, default: !1 },
    type: { default: U.BUTTON },
    image: {},
    state: { default: r.DEFAULT }
  },
  setup(d) {
    const p = d, m = new I().useInjection(), a = new z({ width: 100, height: 55 }), g = a.getLoadingState(), l = a.getShimmerSize(), n = h({}), c = y(), f = T(() => p.state === r.DEFAULT);
    return b(m, (e) => {
      a.setLoadingState(e);
    }), E(() => {
      n.value && (a.calculateShimmerSize(n.value), a.setLoadingState(m.value));
    }), (e, _) => t(g) ? (o(), s(L, {
      key: 1,
      class: w(["sequiter-button-shimmer", { larger: e.larger }]),
      style: B([
        { width: t(l).width + "px" },
        { "min-height": t(l).height + "px" }
      ])
    }, null, 8, ["class", "style"])) : (o(), u("button", k({
      key: 0,
      ref_key: "buttonElement",
      ref: n,
      class: [e.$options.name, e.variant, e.state, { "has-icon": e.image, larger: e.larger }],
      type: e.type
    }, t(c), {
      disabled: !f.value
    }), [
      N("span", P, [
        e.image ? (o(), u("span", V, [
          A(C, { imageObj: e.image }, null, 8, ["imageObj"])
        ])) : i("", !0),
        v(e.$slots, "default", {}, void 0, !0)
      ]),
      e.state === t(r).PROCESSING ? (o(), s(t(j), { key: 0 })) : i("", !0),
      e.state === t(r).SUCCESS ? (o(), s(t(q), { key: 1 })) : i("", !0)
    ], 16, M));
  }
});
export {
  W as default
};
//# sourceMappingURL=sequiter-button.vue2.js.map
